import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@material-ui/core/Typography';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import { Grid } from '@mui/material';
import { DialogContentText } from '@material-ui/core';
// import { event } from 'react-ga';


const AddPoint = ({
    openADD,
    onCloseADD,
    setType,
    setDtRegisterADD,
    setJustificationADD,
    row,
    creatTimesheet,
    handleMenuCloseAtividade,
    handleCloseAdd,
    type,
    dtRegisterADD,
    startLoading,
}) => {
    const [typeAdd, setTypeAdd] = useState('Tipo')
    const [disabled, setDisabled] = useState(false)
    const [messageDisabled, setMessageDisabled] = useState('')
    const [justification, setJustification] = useState('')


    const handleTimeChange = (e) => {
        setDtRegisterADD(
            {
                horary: e.target.value,
                dtRef: row.dtRef
            }
        );
    };

    const handleTypeChange = (e) => {
        setType(e.target.value);
        setTypeAdd(e.target.value)
    };
    const handleJustificationChange = (e) => {
        const value = e.target.value;
        if (!value) {
            return setMessageDisabled('O campo Justificativa é obrigatório.');
        }
        setDisabled(false)
        setMessageDisabled('')
        setJustificationADD(value);
        setJustification(value)
    };

    const handleClick = () => {
        if (!justification) {
            setDisabled(true)
            return setMessageDisabled('O campo Justificativa é obrigatório.')
        }
        onCloseADD(false)
        creatTimesheet();
        handleMenuCloseAtividade();
        setTypeAdd('Tipo')
        handleCloseAdd()
        setJustificationADD('');
        setJustification('')
        startLoading()
    }

    const handleCloseModal = () => {
        onCloseADD(false)
        setJustificationADD('');
        setJustification('')
        setMessageDisabled('')
        setDisabled(false)
    }

    return (
        <>
            <Dialog
                open={openADD}
                onClose={() => onCloseADD(false)}
                maxWidth="md"
                PaperProps={{
                    style: styles.Dialog
                }}
                scroll='paper'
            >
                <DialogTitle style={styles.DialogTitle}>
                    Informe o horário, o tipo e uma justificativa.
                </DialogTitle>
                <DialogContent style={styles.DialogContent}>
                    <FormControl style={styles.FormControl} >
                        <Select
                            style={styles.Select}
                            value={type}
                            onChange={handleTypeChange}
                        >
                            <MenuItem value="Tipo" disabled>Tipo</MenuItem>
                            <MenuItem value="I">Entrada</MenuItem>
                            <MenuItem value="O">Saida</MenuItem>
                        </Select>

                    </FormControl>
                    <Typography
                        style={styles.TypographyHour}
                    >
                        Horário
                    </Typography>
                    <TextField
                        type="datetime-local"
                        variant="outlined" // Use "outlined" para ter uma borda destacada
                        defaultValue={dtRegisterADD ? dtRegisterADD.horary : null}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        InputProps={{ sx: { borderRadius: 20, height: '40px' } }}
                        style={styles.TextField}
                        onBlur={handleTimeChange}
                    // value={dtRegisterADD}
                    />
                </DialogContent>
                <DialogContent style={{ marginLeft: '3%', marginTop: '-10%' }}>
                    <TextField
                        id="outlined-basic"
                        label="Justificativa"
                        variant="outlined"
                        sx={{ "& .MuiOutlinedInput-notchedOutline": { borderTop: "none", borderLeft: "none", borderRight: "none" } }}
                        style={{ width: '96%', marginTop: '5%' }}
                        onBlur={handleJustificationChange}
                    />
                    <Typography
                        style={{ marginLeft: '2%', marginTop: '2%', color: 'red' }}
                    >
                        {messageDisabled}
                    </Typography>
                    <Grid style={{ display: 'flex' }}>
                        <Button
                            onClick={handleClick}
                            variant="contained" style={styles.ButtonConfirm}
                            disabled={disabled}
                        >
                            Confirmar
                        </Button>
                        <Button
                            variant="contained"
                            style={styles.ButtonClose}
                            onClick={handleCloseModal}>
                            Fechar
                        </Button>
                    </Grid>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default AddPoint;

const styles = {
    Dialog: {
        backgroundColor: 'white',
        borderRadius: '20px',
        width: '600px',
        height: '350px'
    },
    DialogTitle: {
        fontSize: '22px',
        marginTop: '4%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    DialogContent: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    FormControl: { width: '35%', borderRadius: '20px' },
    Select: {
        borderRadius: '30px', // ou qualquer valor que dê a forma de um círculo
        padding: '0px 10px', // ajuste o preenchimento conforme necessário
        height: '40px'
    },
    TypographyHour: { marginLeft: '2%', marginTop: '2%' },
    TextField: {
        width: '35%',
        marginLeft: '2%'
    },
    ButtonConfirm: {
        backgroundColor: '#4851de',
        color: 'white',
        borderRadius: '20px',
        marginLeft: '10.5%',
        height: '50px',
        marginTop: '6%',
        width: '35%'
    },
    ButtonClose: {
        backgroundColor: 'white',
        color: '#4851de',
        borderRadius: '20px',
        marginLeft: '1.5%',
        height: '50px',
        marginTop: '6%',
        width: '35%',
        border: '1px solid #4851de'
    }
}